// Pagina informativa privacy.
// Versione iniziale generica fornita dal CLAUDE.md sez. 2.7.5.
// Sprint 4: customizzabile per installazione dal pannello configurazione.

import { Link } from 'react-router';
import { AudiqWordmark, RuleBicolor } from '@audiq/ui';

export function InformativaPage() {
  return (
    <div
      className="mx-auto max-w-2xl p-6"
      style={{ background: 'var(--surface)', color: 'var(--ink)' }}
    >
      <header className="mb-6 flex items-center justify-between">
        <AudiqWordmark size="md" />
        <Link to="/start" className="text-sm" style={{ color: 'var(--mute)' }}>
          ← Torna
        </Link>
      </header>

      <h1 className="serif mb-2 text-3xl">Informativa Privacy</h1>
      <RuleBicolor className="mb-6" />

      <article className="space-y-4 text-sm leading-relaxed" style={{ color: 'var(--ink)' }}>
        <p>
          <strong>Titolare del trattamento</strong>: il professionista o l'ente che ha attivato
          Audiq presso il proprio sportello.
        </p>
        <p>
          Audiq raccoglie informazioni che ci hai fornito durante la conversazione (dati anagrafici
          facoltativi, motivo della visita/contatto, descrizione dei sintomi o della situazione,
          eventuali dati sanitari) per la finalità di preparare il professionista al tuo
          appuntamento.
        </p>
        <p>
          <strong>Base giuridica</strong>: consenso esplicito (Art. 6.1.a e Art. 9.2.a GDPR per dati
          sanitari).
        </p>
        <p>
          <strong>Conservazione</strong>: i tuoi dati vengono cancellati automaticamente dopo 30
          giorni dall'ultima conversazione, salvo richiesta del professionista di mantenerli per
          finalità cliniche.
        </p>
        <p>
          <strong>Trasferimento extra-UE</strong>: per il funzionamento del servizio, le tue
          conversazioni vengono elaborate da Anthropic PBC (USA) sotto Standard Contractual Clauses
          approvate dalla Commissione Europea. Anthropic non utilizza i tuoi dati per addestrare
          modelli AI.
        </p>

        <h2 className="serif mt-8 text-2xl">Modalità voce (opzionale)</h2>
        <p>
          Se scegli di usare Audiq in modalità voce — abilitabile solo se la tua installazione l'ha
          attivata e tu hai dato il consenso esplicito separato:
        </p>
        <ul className="ms-5 list-disc space-y-1 text-sm">
          <li>
            La tua voce viene trasmessa a <strong>Deepgram Inc. (USA)</strong> per la trascrizione
            automatica in testo, sotto Standard Contractual Clauses GDPR.
          </li>
          <li>
            Le risposte di Audiq vengono sintetizzate in voce da{' '}
            <strong>ElevenLabs Inc. (USA)</strong>, idem.
          </li>
          <li>
            <strong>L'audio raw NON viene archiviato</strong> sui server di Audiq: viene trasmesso
            live ai provider e poi scartato. Conserviamo solo la trascrizione testuale (con la
            stessa retention degli altri dati conversazionali).
          </li>
          <li>
            Puoi scegliere modalità voce o testo all'inizio di ogni conversazione. La tua scelta non
            influisce sulla qualità del servizio.
          </li>
        </ul>

        <p>
          <strong>I tuoi diritti</strong>: puoi accedere, rettificare, cancellare i tuoi dati, o
          opporti al trattamento. Puoi anche presentare reclamo al Garante Privacy. La pagina{' '}
          <Link to="/privacy" className="underline" style={{ color: 'var(--primary)' }}>
            /privacy
          </Link>{' '}
          ti permette accesso e cancellazione self-service.
        </p>
        <p className="mono mt-6" style={{ color: 'var(--mute)' }}>
          Versione informativa: 1.1 — Aprile 2026 (Sprint 8 — aggiunta modalità voce)
        </p>
      </article>
    </div>
  );
}
